import { render, staticRenderFns } from "./sectionFooter.vue?vue&type=template&id=23e90cbc&scoped=true&"
import script from "./sectionFooter.vue?vue&type=script&lang=js&"
export * from "./sectionFooter.vue?vue&type=script&lang=js&"
import style0 from "./sectionFooter.vue?vue&type=style&index=0&id=23e90cbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e90cbc",
  null
  
)

export default component.exports